import { useState } from "react";
import { CrearEntidadForm, Input } from "@/components/ui";
import { toastError } from "@/lib/toast";
import { useCrearArea } from "../hooks/use-area-mutations";

/**
 * Formulario de creación · vive sobre la tabla cuando el usuario hace
 * click en "Nueva área". Validación mínima inline (nombre obligatorio) ·
 * la mutation se encarga del feedback y de cerrar el form via callback.
 */
export function AreaCrearForm({ onSalir }: { onSalir: () => void }) {
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const crear = useCrearArea({ onCreado: onSalir });

  const submit = () => {
    if (!nombre.trim()) {
      toastError({ title: "Datos incompletos", message: "Nombre obligatorio." });
      return;
    }
    crear.mutate({
      nombre: nombre.trim(),
      descripcion: descripcion.trim() || null,
    });
  };

  return (
    <CrearEntidadForm
      titulo="Nueva área"
      descripcion="El nombre debe ser único. La descripción es opcional."
      onCancelar={onSalir}
      onCrear={submit}
      creando={crear.isPending}
    >
      <Input label="Nombre" placeholder="Tesorería" value={nombre} onChange={(e) => setNombre(e.currentTarget.value)} required />
      <Input label="Descripción" placeholder="Coordina los pagos a proveedores" value={descripcion} onChange={(e) => setDescripcion(e.currentTarget.value)} />
    </CrearEntidadForm>
  );
}
